import React from "react";

const StandardCheckoutImage = () => {
  return (
    <svg
      width="184"
      height="170"
      viewBox="0 0 184 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Illustration - Standard Checkout">
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H184V191H4C1.79086 191 0 189.209 0 187V4Z"
          fill="#D9DAF9"
        />
        <path
          d="M92.2989 133.448C102.365 133.448 110.525 135.187 110.525 137.332C110.525 139.478 102.365 141.217 92.2989 141.217C82.2323 141.217 74.0714 139.478 74.0714 137.332C74.0715 135.187 82.2324 133.448 92.2989 133.448ZM29.251 105.36C30.5807 105.36 31.7073 106.229 32.0948 107.43C32.4011 107.254 32.7563 107.153 33.1348 107.153C34.29 107.153 35.2266 108.089 35.2266 109.245C35.2266 110.4 34.29 111.336 33.1348 111.336H25.6651C24.3449 111.336 23.2745 110.266 23.2745 108.946C23.2745 107.626 24.3449 106.555 25.6651 106.555C26.0359 106.555 26.3871 106.64 26.7003 106.79C27.2254 105.933 28.1715 105.36 29.251 105.36ZM151.164 53.3686C154.603 53.3688 157.425 56.0094 157.713 59.3735C158.322 58.9773 159.049 58.7465 159.829 58.7465C161.974 58.7466 163.713 60.486 163.713 62.6313C163.713 64.7766 161.974 66.5159 159.829 66.5161C159.729 66.5161 159.629 66.5118 159.53 66.5043V66.5161H142.199V66.5063C139.863 66.3525 138.016 64.4086 138.016 62.0336C138.016 59.5583 140.023 57.5513 142.498 57.5512C143.349 57.5512 144.145 57.7886 144.823 58.2006C145.587 55.4152 148.136 53.3686 151.164 53.3686ZM73.3389 41.7827C75.118 41.7828 76.6376 42.8936 77.2422 44.4594C77.4201 44.3848 77.6154 44.3432 77.8204 44.3432C78.3451 44.3432 78.8068 44.6142 79.0733 45.0229C79.4188 44.8613 79.8044 44.7709 80.211 44.7709C81.6962 44.7709 82.9005 45.9752 82.9005 47.4604C82.9002 48.8668 81.8202 50.0208 80.4444 50.1391V50.1489H69.0899V50.1391C69.0131 50.1457 68.935 50.1489 68.8565 50.1489C67.3714 50.1489 66.1673 48.9454 66.1671 47.4604C66.1671 45.9752 67.3713 44.7709 68.8565 44.7709C69.0133 44.7709 69.167 44.7842 69.3165 44.81C69.818 43.0619 71.4296 41.7827 73.3389 41.7827Z"
          fill="#A99DD2"
        />
        <path
          d="M53.7528 80.2609H130.845V126.277C130.845 126.937 130.31 127.472 129.65 127.472H54.948C54.2879 127.472 53.7528 126.937 53.7528 126.277V80.2609Z"
          fill="white"
        />
        <path
          d="M51.96 71.6252C51.96 69.7935 53.4449 68.3087 55.2765 68.3087H129.321C131.153 68.3087 132.638 69.7935 132.638 71.6252V80.2609H51.96V71.6252Z"
          fill="#E5E7EC"
        />
        <path
          d="M66.3027 74.2835C66.3027 74.9429 65.7676 75.4774 65.1075 75.4774C64.4474 75.4774 63.9122 74.9429 63.9122 74.2835C63.9122 73.6241 64.4474 73.0895 65.1075 73.0895C65.7676 73.0895 66.3027 73.6241 66.3027 74.2835Z"
          fill="#292A33"
        />
        <path
          d="M62.717 74.2835C62.717 74.9429 62.1819 75.4774 61.5218 75.4774C60.8617 75.4774 60.3266 74.9429 60.3266 74.2835C60.3266 73.6241 60.8617 73.0895 61.5218 73.0895C62.1819 73.0895 62.717 73.6241 62.717 74.2835Z"
          fill="#292A33"
        />
        <path
          d="M59.1313 74.2835C59.1313 74.9429 58.5962 75.4774 57.9361 75.4774C57.276 75.4774 56.7409 74.9429 56.7409 74.2835C56.7409 73.6241 57.276 73.0895 57.9361 73.0895C58.5962 73.0895 59.1313 73.6241 59.1313 74.2835Z"
          fill="#292A33"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M129.65 70.1015H54.9481C54.2879 70.1015 53.7528 70.6366 53.7528 71.2967V126.277C53.7528 126.937 54.2879 127.472 54.948 127.472H129.65C130.31 127.472 130.845 126.937 130.845 126.277V71.2967C130.845 70.6366 130.31 70.1015 129.65 70.1015ZM54.9481 68.3087C53.2978 68.3087 51.96 69.6465 51.96 71.2967V126.277C51.96 127.927 53.2978 129.265 54.948 129.265H129.65C131.3 129.265 132.638 127.927 132.638 126.277V71.2967C132.638 69.6465 131.3 68.3087 129.65 68.3087H54.9481Z"
          fill="#292A33"
        />
        <path
          d="M156.542 122.094C156.542 121.434 157.077 120.899 157.737 120.899H167.897C168.557 120.899 169.092 121.434 169.092 122.094C169.092 122.754 168.557 123.289 167.897 123.289H157.737C157.077 123.289 156.542 122.754 156.542 122.094Z"
          fill="#292A33"
        />
        <path
          d="M132.638 120.899H152.244C152.909 120.899 153.449 121.438 153.449 122.104C153.449 122.77 152.909 123.309 152.244 123.309H132.638V120.899Z"
          fill="#292A33"
        />
        <path
          d="M35.2269 122.094C35.2269 121.434 35.762 120.899 36.4221 120.899H51.96V123.289H36.4221C35.762 123.289 35.2269 122.754 35.2269 122.094Z"
          fill="#292A33"
        />
        <path
          d="M25.0675 122.094C25.0675 121.434 25.6026 120.899 26.2627 120.899H31.0436C31.7037 120.899 32.2388 121.434 32.2388 122.094C32.2388 122.754 31.7037 123.289 31.0436 123.289H26.2627C25.6026 123.289 25.0675 122.754 25.0675 122.094Z"
          fill="#292A33"
        />
        <path
          d="M51.9601 78.4676H132.638V80.2604H51.9601V78.4676Z"
          fill="#292A33"
        />
        <path
          d="M90.8047 136.727C90.8047 137.226 90.3999 137.632 89.9004 137.632H84.8291C84.1691 137.632 83.6339 137.097 83.6338 136.437C83.6338 135.777 84.169 135.242 84.8291 135.242H88.4141V129.265H90.8047V136.727ZM96.1836 135.242H99.7686C100.429 135.242 100.964 135.777 100.964 136.437C100.964 137.097 100.429 137.632 99.7686 137.632H94.6973C94.1978 137.632 93.793 137.226 93.793 136.727V129.265H96.1836V135.242ZM141.655 116.661C141.271 117.046 140.676 117.126 140.204 116.856L132.638 112.532V109.543L140.796 114.205C140.918 114.275 141.072 114.251 141.167 114.148L148.176 106.556H146.383C145.723 106.556 145.188 106.021 145.188 105.361C145.188 104.701 145.723 104.165 146.383 104.165H155.944C156.604 104.165 157.14 104.701 157.14 105.361C157.139 106.021 156.604 106.556 155.944 106.556H151.761L141.655 116.661Z"
          fill="#6145F7"
        />
        <rect
          x="141.975"
          y="83.9315"
          width="17.635"
          height="17.5863"
          rx="8.439"
          fill="#6145F7"
        />
        <path
          d="M151.726 88.0383V89.0822C153.038 89.3131 153.835 90.2159 153.819 91.3019L152.283 91.3283C152.189 90.6567 151.886 90.2473 151.084 90.2473C150.256 90.2474 149.745 90.6253 149.745 91.176C149.745 91.6167 149.985 91.8378 150.803 92.0529L152.017 92.3517C153.387 92.6823 153.955 93.5118 153.955 94.6506C153.955 95.7943 153.085 96.5919 151.694 96.7756V97.715H150.381V96.7805C148.953 96.6177 148.031 95.9039 147.891 94.5764L149.475 94.5451C149.636 95.2377 150.219 95.6055 151.053 95.6057C151.803 95.6057 152.34 95.2008 152.34 94.6603C152.34 94.0993 151.991 93.8682 151.257 93.7004L150.021 93.4328C148.87 93.1966 148.13 92.5196 148.114 91.3547C148.104 90.1163 149.063 89.282 150.407 89.0773V88.0383H151.726Z"
          fill="white"
        />
        <mask
          id="mask0_9355_281"
          maskUnits="userSpaceOnUse"
          x="147"
          y="88"
          width="7"
          height="10"
        >
          <path
            d="M151.726 88.0383V89.0822C153.038 89.3131 153.835 90.2159 153.819 91.3019L152.283 91.3283C152.189 90.6567 151.886 90.2473 151.084 90.2473C150.256 90.2474 149.745 90.6253 149.745 91.176C149.745 91.6167 149.985 91.8378 150.803 92.0529L152.017 92.3517C153.387 92.6823 153.955 93.5118 153.955 94.6506C153.955 95.7943 153.085 96.5919 151.694 96.7756V97.715H150.381V96.7805C148.953 96.6177 148.031 95.9039 147.891 94.5764L149.475 94.5451C149.636 95.2377 150.219 95.6055 151.053 95.6057C151.803 95.6057 152.34 95.2008 152.34 94.6603C152.34 94.0993 151.991 93.8682 151.257 93.7004L150.021 93.4328C148.87 93.1966 148.13 92.5196 148.114 91.3547C148.104 90.1163 149.063 89.282 150.407 89.0773V88.0383H151.726Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_9355_281)">
          <rect
            x="143.645"
            y="85.4679"
            width="14.5552"
            height="14.515"
            fill="white"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M101.263 95.9553C100.228 95.9553 99.4816 96.5571 99.2985 97.2006C99.1846 97.601 98.7676 97.8333 98.3672 97.7193C97.9668 97.6054 97.7346 97.1884 97.8486 96.7881C98.2508 95.3743 99.6905 94.4478 101.263 94.4478C102.835 94.4478 104.275 95.3743 104.677 96.7881C104.791 97.1884 104.559 97.6054 104.158 97.7193C103.758 97.8333 103.341 97.601 103.227 97.2006C103.044 96.5571 102.298 95.9553 101.263 95.9553Z"
          fill="#292A33"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.5299 95.9553C83.495 95.9553 82.7487 96.5571 82.5656 97.2006C82.4517 97.601 82.0347 97.8333 81.6343 97.7193C81.2339 97.6054 81.0017 97.1884 81.1156 96.7881C81.5179 95.3743 82.9576 94.4478 84.5299 94.4478C86.1022 94.4478 87.5418 95.3743 87.9441 96.7881C88.058 97.1884 87.8258 97.6054 87.4254 97.7193C87.025 97.8333 86.6081 97.601 86.4941 97.2006C86.311 96.5571 85.5647 95.9553 84.5299 95.9553Z"
          fill="#292A33"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.4261 106.4C85.8424 106.4 86.1799 106.738 86.1799 107.154C86.1799 108.058 86.9127 108.791 87.8166 108.791H96.7807C97.6847 108.791 98.4174 108.058 98.4174 107.154C98.4174 106.738 98.7549 106.4 99.1712 106.4C99.5875 106.4 99.9249 106.738 99.9249 107.154C99.9249 108.891 98.5172 110.298 96.7807 110.298H87.8166C86.0801 110.298 84.6724 108.891 84.6724 107.154C84.6724 106.738 85.0098 106.4 85.4261 106.4Z"
          fill="#292A33"
        />
        <path
          d="M51.9593 112.531V109.543L41.5712 117.457C40.7439 118.088 41.0607 119.401 42.0844 119.584L62.7163 123.288V120.897L44.7879 117.909L51.9593 112.531Z"
          fill="#6145F7"
        />
        <path
          d="M65.7042 117.909H66.8995C67.5596 117.909 68.0947 118.444 68.0947 119.104C68.0947 119.765 67.5596 120.3 66.8995 120.3H66.3018C65.3117 120.3 64.509 121.102 64.509 122.092C64.509 123.083 65.3117 123.885 66.3018 123.885H68.6923C69.3524 123.885 69.8875 124.42 69.8875 125.081C69.8875 125.741 69.3524 126.276 68.6923 126.276H65.7042C63.7239 126.276 62.1186 124.67 62.1186 122.69V121.495C62.1186 119.515 63.7239 117.909 65.7042 117.909Z"
          fill="#6145F7"
        />
        <path
          d="M25.8391 72.536C29.2503 72.5361 32.0497 75.1416 32.3489 78.4657C33.032 77.9232 33.897 77.5985 34.8381 77.5985C37.047 77.5985 38.8379 79.3841 38.8381 81.5868C38.8381 83.7897 37.0471 85.576 34.8381 85.576C34.7868 85.576 34.7357 85.5741 34.6848 85.5721V85.576H16.8391V85.5741C16.8138 85.5745 16.7884 85.576 16.7629 85.576C14.1718 85.576 12.0708 83.4813 12.0706 80.8973C12.0706 78.3132 14.1716 76.2177 16.7629 76.2177C17.8215 76.2177 18.7983 76.5674 19.5833 77.1571C20.3985 74.4825 22.8907 72.536 25.8391 72.536Z"
          fill="#A99DD2"
        />
      </g>
    </svg>
  );
};

export default StandardCheckoutImage;
